class Vacancy {
    id = null;
    job_title = '';
    status_id = 1;
    joining_date = null;
    asap = false;
    number_of_offered_positions = 1;
    additional_information = '';
    salary = '';
    salary_details = '';
    rotation = '';
    vessel_types = [];
    ranks = [];
    job_requirements = '';
    vessel_information = '';
    active = true;
    entity_id = null;

    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = true;
            }
        }
    }
}

export default Vacancy;
